// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input input[data-v-3235b23f]{width:100%}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentConfigModal/TextInput.vue"],"names":[],"mappings":"AAGC,mCACC,UAAA","sourcesContent":["\n// TODO: move to global scss file\n.text-input {\n\tinput {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
